module.exports = __webpack_public_path__ + "img/FAW.771f42c3.png";